module.exports = __webpack_public_path__ + "static/media/hourglass-start.a86ca8f3.svg";